export const ctGameDefault = 'Catalyst Portal';
export const ctGameTitle = 'Catalyst Portal';

// #region Error Message
export const ERR_INPUT_REQUIRED = 'This field is required';
export const ERR_DUPLICATE_NAME_VALUE = 'Please enter unique name';
// #endregion
